exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonGroup {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap; }\n  .buttonGroup__download {\n    margin-right: 10px; }\n    .buttonGroup__download .downButton {\n      font-size: 12px; }\n  .buttonGroup__reset {\n    margin-left: 10px; }\n\n.UploadSpacing {\n  font-weight: 600;\n  letter-spacing: 2px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/buttonGroup.style.scss
// module id = 720
// module chunks = 0